import * as z from 'zod'
import { DNoteListItem, DNoteSingleItem, NoteListItem, NoteSingleItem } from '../NoteEntity.js'
import { GetApiContract, PutApiContract } from './ApiContract.js'
import { Selectable, ShallowDehydrateObject } from 'kysely'
import { Notes } from '../../db.js'

export interface GetNoteListRequest extends GetApiContract {
    Response: Array<DNoteListItem>
    ResponseJson: Array<NoteListItem>
}

export interface GetNoteSingleItemRequest extends GetApiContract {
    Response: DNoteSingleItem
    ResponseJson: NoteSingleItem
}

export const putNoteSchema = z
    .object({
        content: z.string().nullable(),
    })
    .and(
        z.union([
            z.object({ convertibleId: z.string() }),
            z.object({ issueId: z.string() }),
            z.object({ warrantId: z.string() }),
        ]),
    )

export interface PutNoteRequest extends PutApiContract {
    Body: z.infer<typeof putNoteSchema>
    Response: Selectable<Notes>
    ResponseJson: ShallowDehydrateObject<Selectable<Notes>>
}
